export default function About() {
  return (
    <section id="about" className="py-32 bg-gradient-to-b from-black via-gray-900 to-black relative overflow-hidden">
      <div className="absolute inset-0">
        <div className="absolute top-1/3 left-1/4 w-96 h-96 bg-red-500/10 rounded-full blur-3xl animate-pulse"></div>
        <div className="absolute bottom-1/3 right-1/4 w-96 h-96 bg-orange-500/10 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '1.5s' }}></div>
      </div>

      <div className="container mx-auto px-6 relative">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            {/* 左側：コンテンツ */}
            <div className="space-y-8">
              <div>
                <div className="inline-block mb-6">
                  <span className="text-red-400 text-sm font-bold tracking-widest" style={{ fontFamily: '"Montserrat", sans-serif' }}>ABOUT US</span>
                </div>
                
                <h2 className="text-6xl font-black text-white mb-8" style={{ fontFamily: '"Bebas Neue", sans-serif' }}>
                  革新的な<br />
                  <span className="bg-gradient-to-r from-red-500 to-orange-500 bg-clip-text text-transparent">
                    クリエイティブ
                  </span><br />
                  エージェンシー
                </h2>
                
                <p className="text-lg text-gray-300 leading-relaxed mb-8" style={{ fontFamily: '"Montserrat", sans-serif' }}>
                  合同会社オフィスWoWは、平成29年4月14日に設立された革新的な広告代理店です。
                  神奈川県相模原市を拠点に、<strong className="text-red-400">創造性と戦略性を融合</strong>した
                  広告・宣伝企画の制作を手がけています。
                </p>
                
                <p className="text-lg text-gray-300 leading-relaxed mb-12" style={{ fontFamily: '"Montserrat", sans-serif' }}>
                  私たちは「WoW（驚き）」を企業理念に、クライアントのビジネスに
                  <strong className="text-orange-400">革命的なインパクト</strong>をもたらす
                  広告ソリューションを提供し続けています。
                </p>
              </div>

              <div className="grid grid-cols-2 gap-8">
                <div className="bg-white/5 backdrop-blur-xl rounded-2xl border border-red-500/30 p-6 hover:bg-white/10 transition-all">
                  <div className="w-12 h-12 bg-gradient-to-br from-red-500 to-orange-500 rounded-xl flex items-center justify-center mb-4 shadow-lg shadow-red-500/50">
                    <i className="ri-lightbulb-line text-2xl text-white"></i>
                  </div>
                  <h3 className="text-xl font-bold text-white mb-2" style={{ fontFamily: '"Bebas Neue", sans-serif' }}>創造性</h3>
                  <p className="text-gray-400 text-sm" style={{ fontFamily: '"Montserrat", sans-serif' }}>革新的なアイデアと独創的な発想</p>
                </div>
                
                <div className="bg-white/5 backdrop-blur-xl rounded-2xl border border-orange-500/30 p-6 hover:bg-white/10 transition-all">
                  <div className="w-12 h-12 bg-gradient-to-br from-orange-500 to-yellow-500 rounded-xl flex items-center justify-center mb-4 shadow-lg shadow-orange-500/50">
                    <i className="ri-target-line text-2xl text-white"></i>
                  </div>
                  <h3 className="text-xl font-bold text-white mb-2" style={{ fontFamily: '"Bebas Neue", sans-serif' }}>戦略性</h3>
                  <p className="text-gray-400 text-sm" style={{ fontFamily: '"Montserrat", sans-serif' }}>データに基づく効果的な戦略立案</p>
                </div>
              </div>
            </div>

            {/* 右側：会社情報カード */}
            <div className="relative">
              <div className="absolute inset-0 bg-gradient-to-br from-red-500/20 to-orange-500/20 rounded-3xl blur-xl"></div>
              <div className="relative bg-white/5 backdrop-blur-xl rounded-3xl border border-red-500/30 p-8 space-y-6">
                <div className="text-center mb-8">
                  <h3 className="text-3xl font-black text-white mb-2" style={{ fontFamily: '"Bebas Neue", sans-serif' }}>Company Info</h3>
                  <div className="w-20 h-1 bg-gradient-to-r from-red-500 to-orange-500 mx-auto rounded-full"></div>
                </div>
                
                <div className="space-y-6">
                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 bg-gradient-to-br from-red-500 to-orange-500 rounded-lg flex items-center justify-center flex-shrink-0">
                      <i className="ri-building-line text-white text-lg"></i>
                    </div>
                    <div>
                      <h4 className="text-white font-bold mb-1" style={{ fontFamily: '"Montserrat", sans-serif' }}>会社名</h4>
                      <p className="text-gray-300 text-sm" style={{ fontFamily: '"Montserrat", sans-serif' }}>合同会社オフィスWoW</p>
                    </div>
                  </div>
                  
                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 bg-gradient-to-br from-orange-500 to-yellow-500 rounded-lg flex items-center justify-center flex-shrink-0">
                      <i className="ri-map-pin-line text-white text-lg"></i>
                    </div>
                    <div>
                      <h4 className="text-white font-bold mb-1" style={{ fontFamily: '"Montserrat", sans-serif' }}>所在地</h4>
                      <p className="text-gray-300 text-sm" style={{ fontFamily: '"Montserrat", sans-serif' }}>神奈川県相模原市南区松が枝町1番25号</p>
                    </div>
                  </div>
                  
                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 bg-gradient-to-br from-yellow-500 to-red-500 rounded-lg flex items-center justify-center flex-shrink-0">
                      <i className="ri-calendar-line text-white text-lg"></i>
                    </div>
                    <div>
                      <h4 className="text-white font-bold mb-1" style={{ fontFamily: '"Montserrat", sans-serif' }}>設立</h4>
                      <p className="text-gray-300 text-sm" style={{ fontFamily: '"Montserrat", sans-serif' }}>平成29年4月14日</p>
                    </div>
                  </div>
                  
                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 bg-gradient-to-br from-red-500 to-pink-500 rounded-lg flex items-center justify-center flex-shrink-0">
                      <i className="ri-briefcase-line text-white text-lg"></i>
                    </div>
                    <div>
                      <h4 className="text-white font-bold mb-1" style={{ fontFamily: '"Montserrat", sans-serif' }}>事業内容</h4>
                      <p className="text-gray-300 text-sm" style={{ fontFamily: '"Montserrat", sans-serif' }}>広告、宣伝に関する企画、制作及び広告代理店業</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}